var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.412,
    height: 10.06,
    viewBox: "0 0 17.412 10.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "registered_student",
    "data-name": "registered student",
    transform: "translate(-5 -21.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35570",
    "data-name": "Group 35570",
    transform: "translate(5 21.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64108",
    "data-name": "Path 64108",
    d: "M6.161,973.4A1.158,1.158,0,0,0,5,974.561V982.3a1.158,1.158,0,0,0,1.161,1.161h15.09a1.158,1.158,0,0,0,1.161-1.161v-7.739a1.158,1.158,0,0,0-1.161-1.161Zm3.869,2.515a1.161,1.161,0,1,1-1.161,1.161A1.161,1.161,0,0,1,10.03,975.916Zm4.45,0h6a.387.387,0,1,1,0,.774h-6a.387.387,0,1,1,0-.774Zm0,2.128h6a.387.387,0,0,1,0,.774h-6a.387.387,0,0,1,0-.774Zm-4.45.967c1.393,0,2.515.741,2.515,1.614v.32H7.515v-.32C7.515,979.752,8.637,979.011,10.03,979.011Zm4.45,1.161h6a.387.387,0,0,1,0,.774h-6a.387.387,0,0,1,0-.774Z",
    transform: "translate(-5 -973.401)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.66c907aab3464dcf2979488988858338.svg";
export { ForwardRef as ReactComponent };